import Vue from 'vue';
import businessHourExceptionTransformer from './../../transformers/businessHourException';
import all from './all';
import store from './../../store';

const success = (response, resolve, e) => {
  store.dispatch('storeBusinessHourException', e);
  all();
  resolve(response);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default businessHour => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post('business_hour_exceptions', businessHourExceptionTransformer.send(businessHour))
    .then((response) => {
      success(response, resolve, businessHour);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/businessHourException/store.js